

















































































// tslint:disable-next-line: no-var-requires
const signalR = require('@microsoft/signalr');
import Vue from 'vue';
import { EnvironmentConstants } from '@/types';
import { mstoreSettings } from '@/settings/mstoreSettings';
import { mapGetters } from 'vuex';
import { UserNotificationService } from '@/services/UserNotificationService';
import { BTableHelpers } from '@/mixins/bTable';
import { BvTableFieldArray } from 'bootstrap-vue';
import BackgroundExportDownload from '@/components/document/BackgroundExportDownload.vue';
import DefaultNotificationAction from '@/components/userNotifications/DefaultNotificationAction.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { BvModalEvent } from 'bootstrap-vue';
import { UserNotificationStatus } from '@/services/GeneratedApi';
import BackgroundPrintPreview from '../document/BackgroundPrintPreview.vue';

export default Vue.extend({
  name: 'UserNotifications',
  data(this: any) {
    return {
      userNotifications: [],
      setNotificationsSeen: false,
      isLinkActionActive: false,
      linkData: {},
      linkActionStatus: '',
      activeLinkId: null,
      isLinkActionStatus: '',
      linkActionIsDelete: false,
      submitting: false,
      UserNotificationStatus
    };
  },
  mixins: [BTableHelpers],
  props: {
    showNotifications: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    async connectToSignalRHubAsync(this: any) {
      await this.buildSignalRConnectionAsync();
      await this.CONNECTION.on('NotificationReceived', (data: any) => {
        this.userNotifications = data;
      });
    },
    async buildSignalRConnectionAsync(this: any) {
      const baseUrl = this.getSignalRHubBaseUrl();
      this.CONNECTION = new signalR.HubConnectionBuilder()
        .withUrl(`${baseUrl}/signalrhubs/UserNotification`, {
          accessTokenFactory: () => this.oidcAccessToken
        })
        .configureLogging(signalR.LogLevel.None)
        .build();
      try {
        await this.CONNECTION.start();
      } catch (error) {
        this.$log(error);
      }
    },
    getSignalRHubBaseUrl(): string {
      return process.env.NODE_ENV === 'production' ? mstoreSettings.baseUrl : EnvironmentConstants.DevServerBaseUrl;
    },
    async getNotificationsAsync(this: any) {
      try {
        this.submitting = true;
        this.userNotifications = await UserNotificationService.getNotificationsAsync();
      } catch (error) {
        this.$log(error);
      } finally {
        this.submitting = false;
      }
    },
    async setNotificationsSeenAsync(this: any) {
      try {
        this.userNotifications = await UserNotificationService.setNotificationsSeenAsync();
      } catch (error) {
        this.$log(error);
      }
    },
    onNotificationsModalShown(this: any) {
      this.setNotificationsSeen = true;
    },
    hideNotificationsModalOnError(this: any) {
      this.showModal = false;
      this.setNotificationsSeen = false;
    },
    async onHidden(this: any) {
      if (this.haveNotifications && this.setNotificationsSeen) {
        await this.setNotificationsSeenAsync();
      }
    },
    async onLinkClick(this: any, row: any) {
      this.linkActionIsDelete = false;
      this.linkData = JSON.parse(row.actionButtonLink);
      this.isLinkActionActive = true;
      this.activeLinkId = row.id;
    },
    isActionButtonDisabled(this: any, row: any): boolean {
      return this.activeLinkId && (this.activeLinkId !== row.id || this.linkActionIsDelete);
    },
    isDeleteButtonDisabled(this: any, row: any): boolean {
      return row.status === UserNotificationStatus.InProgress || (this.activeLinkId && (this.activeLinkId !== row.id || !this.linkActionIsDelete));
    },
    isActionButtonActive(this: any, row: any): boolean {
      return this.activeLinkId && this.activeLinkId === row.id && !this.linkActionIsDelete;
    },
    isDeleteButtonActive(this: any, row: any): boolean {
      return this.activeLinkId && this.activeLinkId === row.id && this.linkActionIsDelete;
    },
    async onLinkActionCompleted(this: any) {
      await this.getNotificationsAsync();
      this.isLinkActionActive = false;
      this.linkActionIsDelete = false;
      this.activeLinkId = null;
      this.isLinkActionStatus = '';
    },
    async onLinkActionStatus(this: any, status: string) {
      this.isLinkActionStatus = status;
    },
    onDeleteNotificationClick(this: any, row: any) {
      this.linkActionIsDelete = true;
      this.linkData = row.actionButtonLink ? JSON.parse(row.actionButtonLink) : row;
      this.isLinkActionActive = true;
      this.activeLinkId = row.id;
    },
    async onModalOk(this: any, bvModalEvent: BvModalEvent) {
      bvModalEvent.preventDefault();
      await this.getNotificationsAsync();
    }
  },
  computed: {
    ...mapGetters('oidcStore', ['oidcAccessToken']),
    unseenNotificationCount(): number {
      return this.userNotifications ? this.userNotifications.filter((a: any) => !a.isSeen).length : 0;
    },
    haveUnseenNotifications(this: any): boolean {
      return this.unseenNotificationCount > 0;
    },
    haveNotifications(this: any): boolean {
      return this.userNotifications && this.userNotifications.length > 0;
    },
    showModal: {
      get(this: any) {
        return this.showNotifications;
      },
      set(this: any, value: boolean) {
        this.$emit('update:showNotifications', value);
      }
    },
    linkComponent(this: any) {
      return this.linkData?.componentName ?? this.DEFAULT_LINK_COMPONENT;
    }
  },
  created(this: any) {
    this.TABLE_FIELDS = [
      {
        key: 'status',
        label: 'Status',
        sortable: true,
        tdClass: 'text-center'
      },
      {
        key: 'description',
        label: 'Description',
        sortable: true
      },
      {
        key: 'createdDate',
        label: 'Date',
        sortable: true
      },

      {
        key: 'message',
        label: 'Message',
        sortable: true
      },
      {
        key: 'actions',
        label: '',
        sortable: false
      }
    ] as BvTableFieldArray;
  },
  async mounted(this: any) {
    this.CONNECTION = null as any;
    this.DEFAULT_LINK_COMPONENT = 'DefaultNotificationAction';
    await this.connectToSignalRHubAsync();
    await this.getNotificationsAsync();
  },
  components: {
    BackgroundExportDownload,
    MStoreSpinnerButton,
    DefaultNotificationAction,
    BackgroundPrintPreview
  }
});
